var DefaultPickerItem = /** @class */ (function () {
    function DefaultPickerItem() {
    }
    DefaultPickerItem.create = function (id, title) {
        var item = new DefaultPickerItem();
        item.title = title;
        item.id = id;
        return item;
    };
    return DefaultPickerItem;
}());
export { DefaultPickerItem };
